import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        selectedPath: '/',
        selectedIndex: 0,
        comparisons: [
            {
                id: 'joggingShoes',
                image: '/items/shoes.svg',
                units: '#value# par',
                text: 'joggesko',
                info: 'Joggesko – 1000 kr pr par.',
            },
            {
                id: 'electricBikes',
                image: '/items/electric-bike.svg',
                units: '#value# stk.',
                text: 'elsykler',
                info: 'Elsykkel – 30.000 kr pr sykkel.',
            },
            {
                id: 'busCards',
                image: '/items/bus.svg',
                units: '#value# stk.',
                text: '180 dagers periodebilletter',
                textDetails: 'buss periodebilletter',
                info: '180 dagers periodebillett\n4100 kr Voksen.',
            },
            {
                id: 'electricScooterRides',
                image: '/items/kickbike.svg',
                units: '#value# turer',
                text: 'med elsparkesykkel',
                info: 'Turer med elsparkesykkel\n40 kr pr 10 min. tur',
            },
            {
                id: 'carRental',
                image: '/items/long-term-rental-car.svg',
                units: '#value# dager',
                text: 'med leiebil',
                info: 'Leiebil - 2090 kr pr dag.'
            },
            {
                id: 'taxiRides',
                image: '/items/taxi.svg',
                units: '#value# turer',
                text: 'med taxi',
                info: 'Taxiturer – 305 kr pr tur.',
            }
        ],
        priceInfo: {
            joggingShoes: {
                unit: 'Per par',
                price: 1000,
                description: '',
                unitsPerYear: 1
            },
            electricBikes: {
                unit: 'stk.',
                price: 30000,
                description: '',
                unitsPerYear: 1
            },
            busCards: {
                unit: 'Per billett',
                price: 4100, // changed 4100 - 3250 = 850
                description: '',
                unitsPerYear: 1
            },
            electricScooterRides: {
                unit: 'Per 10 min tur',
                price: 40,
                description: '',
                unitsPerYear: 1
            },
            carRental: {
                unit: 'Per dag',
                price: 2090,
                description: '',
                unitsPerYear: 1
            },
            taxiRides: {
                unit: 'Per tur',
                price: 305,
                description: '',
                unitsPerYear: 1
            },
        },
        selections: [
            {
                label: 'Bil, gjennomsnitt',
                title: 'Kostnader ved å eie en gjennomsnittlig bil',
                type: 'vanlig bil',
                price: 520000,
                compareValues: {
                    joggingShoes: 2,
                    electricBikes: 2,
                    busCards: 2,
                    electricScooterRides: 50,
                    carRental: 10,
                    taxiRides: 30
                },
                costs: {
                    writeOffs: 42290,
                    interest: 27755,
                    insurance: 9206,
                    trafficInsuranceFee: 2774,
                    maintenance: 5952,
                    fuel: 15546,
                    oil: 1668,
                    tires: 3618,
                    serviceRepairs: 7587,
                    tolls: 13728
                },
                total: 130123.36,
                video: '/videos/bil_2.mp4',
                fallback: '/videos/bil_2.png',
                idleTime: 4
            },
            {
                label: 'Bil, liten',
                title: 'Kostnader ved å eie en liten bil',
                type: 'liten bil',
                price: 250000,
                compareValues: {
                    joggingShoes: 1,
                    electricBikes: 1,
                    busCards: 1,
                    electricScooterRides: 30,
                    carRental: 5,
                    taxiRides: 20
                },
                costs: {
                    writeOffs: 27339,
                    interest: 18054,
                    insurance: 7582,
                    trafficInsuranceFee: 2774,
                    maintenance: 5603,
                    fuel: 12487,
                    oil: 1480,
                    tires: 3037,
                    serviceRepairs: 6813,
                    tolls: 13728
                },
                total: 98897.55,
                video: '/videos/bil_1.mp4',
                fallback: '/videos/bil_1.png',
                idleTime: 4
            },
            {
                label: 'Bil, stor/SUV',
                title: 'Kostnader ved å eie en SUV/stor bil',
                type: 'stor bil/SUV',
                price: 850000,
                compareValues: {
                    joggingShoes: 3,
                    electricBikes: 3,
                    busCards: 4,
                    electricScooterRides: 80,
                    carRental: 15,
                    taxiRides: 40
                },
                costs: {
                    writeOffs: 76764,
                    interest: 50120,
                    insurance: 12601,
                    trafficInsuranceFee: 2774,
                    maintenance: 6723,
                    fuel: 19878,
                    oil: 1892,
                    tires: 4990,
                    serviceRepairs: 8687,
                    tolls: 13728
                },
                total: 198155.68,
                video: '/videos/bil_3.mp4',
                fallback: '/videos/bil_3.png',
                idleTime: 4
            },
            {
                label: 'Elbil, gjennomsnitt',
                type: 'vanlig elbil',
                title: 'Kostnader ved å eie en gjennomsnittlig elbil',
                price: 500000,
                compareValues: {
                    joggingShoes: 2,
                    electricBikes: 1,
                    busCards: 2,
                    electricScooterRides: 30,
                    carRental: 10,
                    taxiRides: 20
                },
                costs: {
                    writeOffs: 40946,
                    interest: 28310,
                    insurance: 9390,
                    trafficInsuranceFee: 3176,
                    maintenance: 5952,
                    fuel: 2702,
                    oil: 0,
                    tires: 3980,
                    serviceRepairs: 4742,
                    tolls: 9610
                },
                total: 108807.98,
                video: '/videos/bil_5.mp4',
                fallback: '/videos/bil_5.png',
                idleTime: 4
            },
            {
                label: 'Elbil, liten',
                title: 'Kostnader ved å eie en liten elbil',
                type: 'liten elbil',
                price: 250000,
                compareValues: {
                    joggingShoes: 1,
                    electricBikes: 1,
                    busCards: 1,
                    electricScooterRides: 20,
                    carRental: 5,
                    taxiRides: 5
                },
                costs: {
                    writeOffs: 26534,
                    interest: 18415,
                    insurance: 7734,
                    trafficInsuranceFee: 3176,
                    maintenance: 5603,
                    fuel: 2702,
                    oil: 0,
                    tires: 3037,
                    serviceRepairs: 4258,
                    tolls: 9610
                },
                total: 81069.10,
                video: '/videos/bil_4.mp4',
                fallback: '/videos/bil_4.png',
                idleTime: 4
            },
            {
                label: 'Elbil, stor/SUV',
                title: 'Kostnader ved å eie en stor elbil/SUV',
                type: 'stor elbil/SUV',
                price: 850000,
                compareValues: {
                    joggingShoes: 3,
                    electricBikes: 2,
                    busCards: 3,
                    electricScooterRides: 60,
                    carRental: 15,
                    taxiRides: 50
                },
                // rest: 13019
                costs: {
                    writeOffs: 74069,
                    interest: 51124,
                    insurance: 12852,
                    trafficInsuranceFee: 3176,
                    maintenance: 6723,
                    fuel: 3358,
                    oil: 0,
                    tires: 6488,
                    serviceRepairs: 5430,
                    tolls: 9610
                },
                total: 172828.30,
                video: '/videos/bil_6.mp4',
                fallback: '/videos/bil_6.png',
                idleTime: 4
            }
        ],
        labels: {
            writeOffs: 'Avskrivninger',
            interest: 'Renter av bundet kapital',
            insurance: 'Forsikring',
            trafficInsuranceFee: 'Trafikkforsikringsavgift',
            maintenance: 'Vedlikehold',
            fuel: 'Drivstoff',
            oil: 'Olje',
            tires: 'Dekk',
            serviceRepairs: 'Service og reparasjoner',
            tolls: 'Bompenger'
        }
    },
    actions: {

    },
    mutations: {
        setSelectedPath (path) {
            state.selectedPath = path;
        },
        setSelectedIndex (state, index) {
            state.selectedIndex = index;
        }
    },
    getters: {
        activeSelection (state) {
            return state.selections[state.selectedIndex];
        },
        activeComparisons (state) {
            return state.comparisons.map(c => Object.assign({}, c, {
                value: state.selections[state.selectedIndex].compareValues[c.id],
                priceInfo: state.priceInfo[c.id],
                annualPrice: state.priceInfo[c.id].price * state.selections[state.selectedIndex].compareValues[c.id] * state.priceInfo[c.id].unitsPerYear,
            }));        },
        activeDetails (state) {
            return Object.keys(state.labels)
                .map(k => ({label: state.labels[k], value: state.selections[state.selectedIndex].costs[k]}));
        }
    }
});
